/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LandbotSettings } from './LandbotSettings';
import {
    LandbotSettingsFromJSON,
    LandbotSettingsFromJSONTyped,
    LandbotSettingsToJSON,
} from './LandbotSettings';

/**
 * 
 * @export
 * @interface Settings
 */
export interface Settings {
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    landbotUrlTx?: string;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    landbotLanguage?: string;
    /**
     * 
     * @type {Array<LandbotSettings>}
     * @memberof Settings
     */
    landbotSettings: Array<LandbotSettings>;
}

/**
 * Check if a given object implements the Settings interface.
 */
export function instanceOfSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "landbotSettings" in value;

    return isInstance;
}

export function SettingsFromJSON(json: any): Settings {
    return SettingsFromJSONTyped(json, false);
}

export function SettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Settings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'landbotUrlTx': !exists(json, 'landbotUrlTx') ? undefined : json['landbotUrlTx'],
        'landbotLanguage': !exists(json, 'landbotLanguage') ? undefined : json['landbotLanguage'],
        'landbotSettings': ((json['landbotSettings'] as Array<any>).map(LandbotSettingsFromJSON)),
    };
}

export function SettingsToJSON(value?: Settings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'landbotUrlTx': value.landbotUrlTx,
        'landbotLanguage': value.landbotLanguage,
        'landbotSettings': ((value.landbotSettings as Array<any>).map(LandbotSettingsToJSON)),
    };
}

